/* MTHEME size guide popup: [data-mt-sg-open] opens <dialog id="mt-sg">. Esc (native), X / backdrop close, scroll lock,
   focus returns to the opener. No layout impact while closed. No brand strings. */
(function () {
  'use strict';
  function init() {
    var d = document.getElementById('mt-sg'); if (!d || d.__mtsg) return; d.__mtsg = 1;
    if (d.parentNode !== document.body) document.body.appendChild(d);
    var last = null;
    function onClose() { document.documentElement.classList.remove('mt-sg-lock'); if (last && last.focus) last.focus(); }
    function open(e) {
      if (e) e.preventDefault(); last = document.activeElement;
      if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else d.setAttribute('open', '');
      document.documentElement.classList.add('mt-sg-lock');
      var b = d.querySelector('.mt-sg__body'); if (b) b.scrollTop = 0;
    }
    function close() {
      if (typeof d.close === 'function' && d.open) d.close();
      else if (d.hasAttribute('open')) { d.removeAttribute('open'); onClose(); }
    }
    d.addEventListener('close', onClose);
    d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-mt-sg-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.hasAttribute('open') && typeof d.showModal !== 'function') close(); });
    document.addEventListener('click', function (e) { var t = e.target.closest('[data-mt-sg-open]'); if (t) open(e); });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
